export default {
  title: 'Aviso legal',
  subtitle: 'Aparece en el pie de página de tu tienda online y de tu web solo cuando lo guardas.',
  card_title: 'Aviso legal',
  placeholder: 'Introduce los datos de tu aviso legal',
  status: {
    saved: 'Guardado',
    not_shown: 'Aún no se muestra en tu tienda ni en tu web',
    unsaved: 'Cambios sin guardar: tu tienda y tu web muestran la última versión guardada',
  },
  save: 'Guardar',
  retry: 'Intentar de nuevo',
  preview: {
    title: 'Vista previa del pie de página (tienda y web)',
    terms: 'Condiciones',
    privacy: 'Privacidad',
    cookies: 'Cookies',
    imprint: 'Aviso legal',
  },
  toasts: {
    saved: 'Aviso legal guardado',
    save_failed: 'No se pudo guardar el aviso legal. Inténtalo de nuevo.',
    load_failed: 'No se pudo cargar el aviso legal. Recarga la página.',
  },
};
